
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import Mission from './components/Mission';
import Values from './components/Values';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <AboutHero />
        <Mission />
        <Values />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
